import { _system } from '@umu/ukit-lang';
import { $location } from '@umu/umu-dom';

export const getCDNDomain = () => {
    if (_system('CN')) {
        return 'https://statics-cdn-cn.umucdn.cn';
    } else if (_system('EM')) {
        return 'https://cdn.umu.io';
    }

    return 'https://cdn.umustatic.com';
};

export const getStaticDomain = () => {
    if (_system('EN')) {
        return 'https://statics00.umustatic.com';
    } else if (_system('EM')) {
        return 'https://cdn.umu.io';
    } else if (_system('JP')) {
        return 'https://statics22.umustatic.com';
    } else if (_system('TW')) {
        return 'https://statics11.umustatic.com';
    }

    return 'https://cdn.umustatic.com';
};

export const getPDFDomain = () => {
    if (_system('EN')) {
        return 'https://d1bvk99i2a79wx.cloudfront.net';
    } else if (_system('EM')) {
        return 'https://cdn.umu.io';
    } else if (_system('JP')) {
        return 'https://dpfrzbu0cqnmm.cloudfront.net';
    } else if (_system('TW')) {
        return 'https://d1yemi1ss2f2oh.cloudfront.net';
    }

    return 'https://statics-cdn-cn.umucdn.cn';
};

export const getProfileIndexUrl = (profileId: string) => {
    const host = $location.host.replace('www.', 'm.');
    return `${$location.protocol}//${host}/profile/${profileId}`;
};
